/**
 * 签收单模板系统
 * 根据仓库字段自动选择模板：
 *   - 仓库包含"上海" → shanghai 模板
 *   - 仓库不包含"上海" → chengdu 模板（随货同行单成都格式）
 *
 * 模板结构：
 * - name: 模板名称
 * - cDefine2: 模板标识
 * - title: 单标题
 * - subtitle: 单副标题（可选）
 * - headerRows: 头部信息行（支持3列网格，或 fullWidth 模式）
 * - infoLayout: 'grid' | 'twoColumn'
 * - tableColumns: 表格列定义
 * - footerRows: 页脚行（成都模板使用）
 * - sealArea: 签章区域
 */
const TEMPLATES = [
  // ========== 上海模板 ==========
  {
    name: '上海模板',
    cDefine2: 'shanghai',
    title: '随货同行单',
    subtitle: '受托方：上海协谷供应链管理有限公司',
    // 头部字段: 3行 × 3列 + 1行全宽
    headerRows: [
      [
        { label: '供货方', field: 'supplier', default: '上海佰迦康科技有限公司' },
        { label: '收货单位', field: '收货单位' },
        { label: '发货日期', field: '发货日期' },
      ],
      [
        { label: '销售单号', field: '销售单号' },
        { label: '收货人', field: '收货人' },
        { label: '仓库流水号', field: 'dispatchNo', default: '0' },
      ],
      [
        { label: '配送方式', field: 'shipMethod', default: '快递' },
        { label: '快递联系人', field: '联系方式' },
        { label: '备注', field: '备注', default: '' },
      ],
      [
        { label: '发货单号', field: '发货单号' },
        { label: '收货地址', field: '收货地址' },
        { label: '', field: null, default: '' },
      ],
    ],
    // 表格列: 15列完整字段
    tableColumns: [
      { label: '序号', field: null, width: 30 },
      { label: '产品名称', field: '产品名称', width: 90 },
      { label: '规格/型号', field: '规格型号', width: 80 },
      { label: '批号', field: '批号', width: 70 },
      { label: '序列号', field: null, width: 40 },
      { label: '包装单位', field: '包装单位', width: 55 },
      { label: '包装数量', field: '包装数量', width: 55 },
      { label: '明细单位', field: '明细单位', width: 55 },
      { label: '明细数量', field: '明细数量', width: 55 },
      { label: '生产日期', field: '生产日期', width: 65 },
      { label: '有效期至/失效日期', field: '效期', width: 65 },
      { label: '注册人/备案人/受托生产企业', field: '注册人', width: 100 },
      { label: '注册证号/备案号', field: '注册证号', width: 90 },
      { label: '生产许可证/备案凭证', field: '生产许可证', width: 90 },
      { label: '储运条件', field: '储运条件', width: 70 },
    ],
    sealArea: { left: '供货方盖章处', right: '收货方签字处' },
  },

  // ========== 成都模板 ==========
  {
    name: '成都模板',
    cDefine2: 'chengdu',
    title: '上海佰迦康科技有限公司发货单',
    subtitle: null,
    // 双列信息布局: 左列3行, 右列2行
    infoLayout: 'twoColumn',
    infoLeft: [
      { label: '客户简称', field: '收货单位' },
      { label: '收货地址', field: '收货地址' },
      { label: '联系人及联系方式', field: null, format: (doc) => {
        const name = doc['收货人'] || '';
        const phone = doc['联系方式'] || '';
        return phone ? `${name} / ${phone}` : name;
      }},
    ],
    infoRight: [
      { label: '备注', field: '备注', default: '' },
      { label: '发货日期', field: '发货日期' },
      { label: '发货单号', field: '发货单号' },
    ],
    headerRows: [], // not used when infoLayout='twoColumn'
    // 表格列: 11列（成都格式）
    tableColumns: [
      { label: '规格型号', field: '规格型号', width: 55 },
      { label: '存货名称', field: '产品名称', width: 70 },
      { label: '批号', field: '批号', width: 60 },
      { label: '生产日期', field: '生产日期', width: 60 },
      { label: '失效日期', field: '效期', width: 60 },
      { label: '生产厂家', field: '注册人', width: 80 },
      { label: '生产许可证/\n备案凭证', field: '生产许可证', width: 70 },
      { label: '注册证号', field: '注册证号', width: 70 },
      { label: '储运条件', field: '储运条件', width: 60 },
      { label: '包装单位', field: '包装单位', width: 50 },
      { label: '包装数量', field: '包装数量', width: 50 },
    ],
    // 页脚: 2行 × 4列
    footerRows: [
      [
        { label: '仓库', field: '仓库' },
        { label: '制单人', field: '制单人' },
        { label: '业务员', field: '业务员', default: '' },
        { label: '拣货员', field: null, default: '' },
      ],
      [
        { label: '复核员', field: null, default: '' },
        { label: '复核结果', field: null, default: '' },
        { label: '订单号', field: '销售单号' },
        { label: '发货人签收', field: null, default: '' },
      ],
    ],
    sealArea: { left: '出库确认章', right: '签收人' },
  },
];

/** 通过仓库名称获取模板 */
export function getTemplate(warehouse) {
  if (warehouse && warehouse.includes('上海')) {
    return TEMPLATES.find(t => t.cDefine2 === 'shanghai') || TEMPLATES[0];
  }
  return TEMPLATES.find(t => t.cDefine2 === 'chengdu') || TEMPLATES[0];
}

/** 获取所有模板列表 */
export function getTemplateList() {
  return TEMPLATES.map(t => ({ name: t.name, cDefine2: t.cDefine2 }));
}

export default TEMPLATES;
